import { render, staticRenderFns } from "./PayWithAch.vue?vue&type=template&id=52a8eb8c&scoped=true"
import script from "./PayWithAch.vue?vue&type=script&lang=js"
export * from "./PayWithAch.vue?vue&type=script&lang=js"
import style0 from "./PayWithAch.vue?vue&type=style&index=0&id=52a8eb8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8eb8c",
  null
  
)

export default component.exports